<template>
  <tr>
    <slot/>   
  </tr> 
</template>

<script>
export default {
}
</script>

<style>

</style>